/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-param-reassign */
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import { useState } from 'react';
import useGetPortfolioData from 'hooks/useGetPortfolioData';
import { formatNumber } from 'utils/number';
import { selectors } from 'lib/entities/profile';
import { useSelector } from 'react-redux';
import If from 'global/ErrorHandlers/If';
import { Checkbox, ConfirmationBox, PreviewItem } from './styled';
import orderbookModalStore from './store';

function AmendPreviewVirtual() {
  const { data } = useSelector(selectors);
  const [checked, setChecked] = useState(false);
  const { symbol, price, orders } = orderbookModalStore();
  const portfolioSymbol = useGetPortfolioData(symbol, false, true);

  let dataPreview = {
    stock: '',
    amount: 0,
    lot: 0,
  };

  if (orders.length) {
    dataPreview = orders.reduce(
      (acc, cur) => {
        const LOT = cur.order_total;
        const AMOUNT = cur.order_total * price;
        acc.stock = cur.symbol;
        acc.amount += AMOUNT;
        acc.lot += LOT;

        return acc;
      },
      {
        stock: '',
        amount: 0,
        lot: 0,
      },
    );
  } else {
    dataPreview = {
      stock: symbol,
      amount: portfolioSymbol.available_lot * price,
      lot: portfolioSymbol.available_lot,
    };
  }

  const previewData = [
    {
      label: <Text align="right">Stock</Text>,
      value: <Text>{dataPreview.stock}</Text>,
    },
    {
      label: <Text align="right">Price</Text>,
      value: <Text>{formatNumber(price, false)}</Text>,
    },
    {
      label: <Text align="right">Amount</Text>,
      value: <Text>{formatNumber(dataPreview.amount, false)}</Text>,
    },
    {
      label: <Text align="right">Lot</Text>,
      value: <Text>{formatNumber(dataPreview.lot, false)}</Text>,
    },
  ];

  const updateShowModal = (isChecked) => {
    if (isChecked) {
      const storeData = { id: data.id, status: isChecked };
      localStorage.setItem(
        'trade-orderbook-show-confirmation',
        JSON.stringify(storeData),
      );
    } else {
      localStorage.removeItem('trade-orderbook-show-confirmation');
    }
  };

  return (
    <>
      <Flex direction="column" width="100%">
        {previewData.map((p) => (
          <PreviewItem key={`amend-buy-${p.label}`} className="virtual">
            {p.label}
            {p.value}
          </PreviewItem>
        ))}
      </Flex>

      <ConfirmationBox
        onClick={() => {
          if (checked) {
            setChecked(false);
            updateShowModal(false);
          } else {
            setChecked(true);
            updateShowModal(true);
          }
        }}
      >
        <Flex>
          {/* @ts-expect-error */}
          <Checkbox items="center" justify="center">
            <If condition={checked}>
              <Iconmoon className="icon-toolbar_check" />
            </If>
          </Checkbox>
          <span>Don't show this confirmation again</span>
        </Flex>
      </ConfirmationBox>
    </>
  );
}

export default AmendPreviewVirtual;
